import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { AlertCircle } from 'lucide-react';
import { updateAdditionalOption } from '@/utils/additionalOptions';

const options = [
  {
    field: 'ivAccess', testId: 'iv-access', label: 'IV-Zugang gelegt',
    description: 'Patient wurde über die Maßnahme aufgeklärt und hat eingewilligt'
  },
  {
    field: 'ambulatoryCare', testId: 'ambulatory-care', label: 'Ambulante Versorgung',
    description: 'Verbleib am Einsatzort nach Untersuchung und Behandlung; Transport mit dem Rettungsdienst nicht erforderlich'
  },
  {
    field: 'transportRefusal', testId: 'transport-refusal', label: 'Transportverweigerung',
    description: 'Patient wurde aufgeklärt und verbleibt auf eigenen Wunsch am Einsatzort'
  }
];

export const AdditionalOptions = ({ data = {}, onChange }) => {
  return (
    <Card className="section-card border-warning/30">
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="p-2 bg-warning/10 rounded-lg">
            <AlertCircle className="w-5 h-5 text-[hsl(var(--warning))]" />
          </div>
          <div>
            <CardTitle className="text-2xl">Zusätzliche Optionen</CardTitle>
            <CardDescription className="text-base mt-1">
              Besondere Maßnahmen und Entscheidungen
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {options.map(option => (
          <div key={option.field} className="flex items-center justify-between gap-4 p-4 rounded-lg border-2 border-border bg-card hover:shadow-sm transition-shadow">
            <div className="space-y-1 min-w-0">
              <Label htmlFor={option.field} className="text-base font-semibold cursor-pointer break-words">
                {option.label}
              </Label>
              <p id={`${option.testId}-description`} data-testid={`${option.testId}-description`} className="text-sm text-muted-foreground break-words">
                {option.description}
              </p>
            </div>
            <Switch
              id={option.field}
              data-testid={`${option.testId}-switch`}
              aria-describedby={`${option.testId}-description`}
              className="shrink-0"
              checked={Boolean(data[option.field])}
              onCheckedChange={checked => onChange(updateAdditionalOption(data, option.field, checked))}
            />
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default AdditionalOptions;
